import { render, staticRenderFns } from "./form_libros_new.vue?vue&type=template&id=bec4de20&scoped=true"
import script from "./form_libros_new.vue?vue&type=script&lang=js"
export * from "./form_libros_new.vue?vue&type=script&lang=js"
import style0 from "./form_libros_new.vue?vue&type=style&index=0&id=bec4de20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec4de20",
  null
  
)

export default component.exports